import { useCallback, useEffect, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { LeadFormActions } from '../../../Services/_actions';
import { leadAllCountsAtom, leadDetailObjAtom, userInfoByNumberAtom } from '../../../Services/_states/LeadForm';
import { interveneLeadCampaignAtom } from '../state/interveneAtoms';

export default function useLeadOverview({ phone, isDrawerOpen }) {
  const leadFormActions = LeadFormActions();
  const [leadCounts, setLeadCounts] = useRecoilState(leadAllCountsAtom);
  const [leadDetails] = useRecoilState(leadDetailObjAtom);
  const [userDetailByNumber] = useRecoilState(userInfoByNumberAtom);
  const userDetailRef = useRef(userDetailByNumber);
  useEffect(() => {
    userDetailRef.current = userDetailByNumber;
  }, [userDetailByNumber]);

  const [leadCampaign] = useRecoilState(interveneLeadCampaignAtom);
  const [isLoading, setIsLoading] = useState(false);
  const lastKeyRef = useRef('');

  const campaignId = leadCampaign?.campaign?.proposal_id || userDetailByNumber?.campaign_id || '';
  const leadFormId = leadCampaign?.webForm?.leads_form_id || userDetailByNumber?.leadform_Id || '';

  const refreshCounts = useCallback(async () => {
    if (!phone || !campaignId || !leadFormId) return;
    try {
      const payload = {
        ...userDetailRef.current,
        supplier_id: userDetailRef.current?.supplier_id || phone,
        campaign_id: campaignId,
        leadform_Id: leadFormId,
        phone_number: phone,
      };
      const res = await leadFormActions.getLeadCounts(payload);
      if (res?.status === 200) {
        setLeadCounts(res.data);
      }
    } catch (err) {
      console.error('Failed to load lead counts', err);
    }
  }, [phone, campaignId, leadFormId, leadFormActions, setLeadCounts]);

  useEffect(() => {
    if (!isDrawerOpen || !phone) return;
    const key = `${phone}:${campaignId}:${leadFormId}`;
    if (key === lastKeyRef.current) return;
    lastKeyRef.current = key;

    let cancelled = false;
    const load = async () => {
      setIsLoading(true);
      await refreshCounts();
      setIsLoading(false);
    };
    load();
    return () => {
      cancelled = true;
    };
  }, [isDrawerOpen, phone, campaignId, leadFormId, refreshCounts]);

  return {
    leadCounts,
    leadDetails,
    userDetailByNumber,
    leadCampaign,
    campaignId,
    leadFormId,
    isLoading,
    refreshCounts,
  };
}
